<script src="https://static.line-scdn.net/liff/edge/2/sdk.js"></script>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
<template>
  <v-container>
    <v-layout text-center wrap>
      <span id="main_title">
        <span id="main_title_text">
          <h4>新規会員登録</h4>
        </span>
      </span>
      <span id="header_logo"
        ><img src="https://misemeg.jp/appli/img/misemeg-logo.svg" width="49px"
      /></span>
      <v-flex xs12>
        <table id="tbl_user_regist">
          <tr>
            <td>性別</td>
            <td>
              <input
                type="radio"
                name="gender"
                value="1"
                id="gender"
                checked="checked"
              />&nbsp;男性 &nbsp;
              <input type="radio" name="gender" value="2" id="gender" />&nbsp;女性 &nbsp;
              <input type="radio" name="gender" value="3" id="gender" />&nbsp;その他
              &nbsp;
            </td>
          </tr>
          <tr>
            <td>生年月日</td>
            <td>
              <select class="bd_year" id="bd_year" @change="calValidate()"></select>
              &nbsp;
              <select class="bd_month" id="bd_month" @change="calValidate()">
                <option value="01">&nbsp;1月</option>
                <option value="02">&nbsp;2月</option>
                <option value="03">&nbsp;3月</option>
                <option value="04">&nbsp;4月</option>
                <option value="05">&nbsp;5月</option>
                <option value="06">&nbsp;6月</option>
                <option value="07">&nbsp;7月</option>
                <option value="08">&nbsp;8月</option>
                <option value="09">&nbsp;9月</option>
                <option value="10">10月</option>
                <option value="11">11月</option>
                <option value="12">12月</option>
              </select>
              &nbsp;
              <select class="bd_date" id="bd_date" @change="calValidate()">
                <option value="01">&nbsp;1日</option>
                <option value="02">&nbsp;2日</option>
                <option value="03">&nbsp;3日</option>
                <option value="04">&nbsp;4日</option>
                <option value="05">&nbsp;5日</option>
                <option value="06">&nbsp;6日</option>
                <option value="07">&nbsp;7日</option>
                <option value="08">&nbsp;8日</option>
                <option value="09">&nbsp;9日</option>
                <option value="10">10日</option>
                <option value="11">11日</option>
                <option value="12">12日</option>
                <option value="13">13日</option>
                <option value="14">14日</option>
                <option value="15">15日</option>
                <option value="16">16日</option>
                <option value="17">17日</option>
                <option value="18">18日</option>
                <option value="19">19日</option>
                <option value="20">20日</option>
                <option value="21">21日</option>
                <option value="22">22日</option>
                <option value="23">23日</option>
                <option value="24">24日</option>
                <option value="25">25日</option>
                <option value="26">26日</option>
                <option value="27">27日</option>
                <option value="28">28日</option>
                <option value="29">29日</option>
                <option value="30">30日</option>
                <option value="31">31日</option>
              </select>
              &nbsp;
              <span id="calc_age" class="msg_small"></span>
            </td>
          </tr>
          <tr>
            <td>生活エリア<br /><span class="msg_small">（都道府県）</span></td>
            <td>
              <select class="region" id="region">
                <option value="1">北海道</option>
                <option value="2">青森県</option>
                <option value="3">岩手県</option>
                <option value="4">宮城県</option>
                <option value="5">秋田県</option>
                <option value="6">山形県</option>
                <option value="7">福島県</option>
                <option value="8">茨城県</option>
                <option value="9">栃木県</option>
                <option value="10">群馬県</option>
                <option value="11">埼玉県</option>
                <option value="12">千葉県</option>
                <option value="13" selected>東京都</option>
                <option value="14">神奈川県</option>
                <option value="15">新潟県</option>
                <option value="16">富山県</option>
                <option value="17">石川県</option>
                <option value="18">福井県</option>
                <option value="19">山梨県</option>
                <option value="20">長野県</option>
                <option value="21">岐阜県</option>
                <option value="22">静岡県</option>
                <option value="23">愛知県</option>
                <option value="24">三重県</option>
                <option value="25">滋賀県</option>
                <option value="26">京都府</option>
                <option value="27">大阪府</option>
                <option value="28">兵庫県</option>
                <option value="29">奈良県</option>
                <option value="30">和歌山県</option>
                <option value="31">鳥取県</option>
                <option value="32">島根県</option>
                <option value="33">岡山県</option>
                <option value="34">広島県</option>
                <option value="35">山口県</option>
                <option value="36">徳島県</option>
                <option value="37">香川県</option>
                <option value="38">愛媛県</option>
                <option value="39">高知県</option>
                <option value="40">福岡県</option>
                <option value="41">佐賀県</option>
                <option value="42">長崎県</option>
                <option value="43">熊本県</option>
                <option value="44">大分県</option>
                <option value="45">宮崎県</option>
                <option value="46">鹿児島県</option>
                <option value="47">沖縄県</option>
                <option value="48">海外</option>
              </select>
            </td>
          </tr>
          <tr id="row_select_shop">
            <td colspan="2">
              <span id="shp_select_label"
                >▼&nbsp;よく利用する店舗を選択してください&nbsp;▼</span
              ><br />
              <span id="area_select_shop"></span>
            </td>
          </tr>
          <!--
          <tr id="row_telephone">
            <td>電話番号<br /></td>
            <td>
              <input type="text" id="telephone" name="telephone" minlength="10" maxlength="15" size="15">
              <br />
            </td>
          </tr>
          -->
          <!-- <tr><td colspan="2">&emsp;</td></tr> -->
          <tr id="row_mail_addr">
            <td colspan="2">
              メールアドレス<br />
              <input
                type="text"
                id="mail_addr"
                name="mail_addr"
                minlength="10"
                maxlength="100"
                disabled
              />
            </td>
          </tr>
          <tr id="row_mail_notice">
            <td colspan="2">
              ※メールアドレスの変更は、LINEホーム画面のアカウントから設定してください<br />
            </td>
          </tr>
          <!-- <tr><td colspan="2">&emsp;</td></tr> -->
        </table>
        <!-- <br />新しい会員証を発行する場合<br /> -->
        <br /><br />
        <v-btn large color="info" @click="regist" title="登録" class="regist_btn"
          >&emsp;新規会員証発行&emsp;</v-btn
        >
        <br />
        <br />
        <!-- <br /> -->
        <span id="area_migration" hidden>
          <br />
          プラスチック、紙の会員証をスマホに移行する場合
          <br />
          <v-btn
            large
            color="warning"
            @click="migration"
            title="既存カード登録"
            class="migration_btn"
            id="migration_btn"
            >&emsp;既存カード登録&emsp;</v-btn
          >
          <br />
          <br />
        </span>
        <br />
        <br />
        <!--
        <br />
          <i class="fa fa-arrow-circle-up fa-lg" aria-hidden="true"></i>&emsp;発行済カード（紙カード等）の情報を入力する場合&emsp;<br />
        <br />
        -->
        <!-- ※登録完了後もこの画面が表示される場合は<br />&emsp;画面右上の&nbsp;<span style="font-size:x-large;font-weigth:bold;">×</span>&nbsp;ボタンで閉じて下さい。 -->
        <span id="return2selecter" @click="return2selecter"
          >「新規登録」・「既存カード移行」選択画面に戻る</span
        >
        <br /><br />
        <!-- 
        ※「登録」ボタンを押したあとに移動する画面は<br />左上の「×」ボタンで閉じてください。<br />
        <div id="modal-container">
          <div><img src="https://misemeg.jp/appli/img/reg_fin.png" width="90%"></div>
        </div>
        <br /> -->
        <!-- <v-btn large @click="returntop" title="ＴＯＰ画面に戻る" class="top_btn">ＴＯＰ画面に戻る</v-btn> 
        <br />     -->
      </v-flex>
      <br />
      <br />
      <span id="misemeg_uid" hidden></span>
      <span id="misemeg_uid_status" hidden></span>
      <span id="member_info" hidden></span>
      <span id="chg_digit_info" hidden></span>
      <!-- Snackbar -->
      <div>
        <v-snackbar
          v-model="snackbarFlag"
          color="primary"
          multi-line
          :timeout="snackbarTimeout"
          top
        >
          {{ snackbarText }}
        </v-snackbar>
      </div>
      <br />
      <br />
      <v-flex mb-4 xs12>
        <br /><br />
        <div class="ma-4">
          <span id="copyright"
            ><a
              href="https://www.busicom.co.jp/product/misemeg/mini/?openExternalBrowser=1"
              target="_blank"
              >&emsp;みせめぐ&nbsp;&times;&nbsp;LINEミニアプリ&emsp;<br />&emsp;Copyright
              &copy; BUSICOM.Co.,ltd. </a
            ><br />&emsp;v2.5.0.1&emsp;</span
          >
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style>
.v-main {
  background-color: #f3f3f3;
}
#main_title {
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #00843f;
  color: #ddd;
  width: 100%;
  height: 70px;
  letter-spacing: 0.3em;
  margin-top: -12px;
  margin-left: -12px;
  margin-right: -50px;
}
#main_title_text {
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 0.3em;
  margin-top: 0px;
  margin-left: -10px;
  margin-right: 0px;
}
#header_logo {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -70px;
  margin-left: 0px;
  margin-right: 100px;
}
#tbl_user_regist {
  margin: 0 auto;
  border-collapse: collapse;
  border: 0px solid #000;
  background-color: #fff;
}
#tbl_user_regist td {
  border-collapse: collapse;
  border: 0px solid #000;
  background-color: #fff;
  text-align: left;
  min-width: 100px;
  padding: 10px;
  font-size: large;
}
#tbl_user_regist td.column {
  background-color: #fff;
}
#tbl_user_regist td.data {
  background-color: #fff;
}
#line_logout {
  margin: 0 auto;
}
#copyright {
  margin: 0 auto;
  color: #88b3b3;
  text-decoration: none;
}
#copyright a {
  margin: 0 auto;
  color: #88b3b3;
  text-decoration: none;
}
#bd_year,
#bd_month,
#bd_date {
  height: 45px;
  cursor: pointer;
  border: #88b3b3 1px solid;
  background-color: #f3f3f3;
  box-shadow: 0 2px 0 #f0f0f0;
  border-radius: 2px;
  font-size: large;
  padding: 5px;
}
.region {
  width: 200px;
  height: 45px;
  cursor: pointer;
  border: #88b3b3 1px solid;
  background-color: #f3f3f3;
  box-shadow: 0 2px 0 #f0f0f0;
  border-radius: 2px;
  font-size: large;
  padding: 10px;
}
.select_shop {
  width: 100%;
  height: 45px;
  margin-left: -10px;
  cursor: pointer;
  border: #88b3b3 1px solid;
  background-color: #f3f3f3;
  box-shadow: 0 2px 0 #f0f0f0;
  border-radius: 2px;
  font-size: middle;
  padding: 10px;
}
#select_shop {
  background-color: rgb(204, 231, 130);
  border: 1px solid gray;
  /* width:100%; */
  font-size: middle;
  padding: 5px;
  color: #000;
}
#shp_select_label {
  width: 100%;
  text-align: center;
  font-size: small;
  font-weight: bold;
  color: tomato;
}
#telephone {
  width: 200px;
  height: 45px;
  cursor: pointer;
  border: #88b3b3 1px solid;
  background-color: #f3f3f3;
  box-shadow: 0 2px 0 #f0f0f0;
  border-radius: 2px;
  font-size: middle;
  padding: 10px;
}
#mail_addr {
  width: 100%;
  height: 45px;
  cursor: pointer;
  border: #88b3b3 1px solid;
  background-color: #f3f3f3;
  box-shadow: 0 2px 0 #f0f0f0;
  border-radius: 2px;
  font-size: middle;
  padding: 10px;
}
#area_select_shop {
  width: 100%;
  height: 45px;
  cursor: pointer;
  border: none;
  background-color: #fff;
  box-shadow: 0 2px 0 #f0f0f0;
  border-radius: 2px;
  font-size: middle;
  padding: 10px;
}
.regist_btn {
  width: 50%;
  font-size: x-large;
  font-weight: bold;
}
.migration_btn {
  width: 50%;
  background-color: #f5deb3;
  font-size: x-large;
  font-weight: bold;
}
.top_btn {
  width: 50%;
  font-size: x-large;
  font-weight: bold;
}
.msg_small {
  font-size: x-small;
}
#modal-container {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  display: block;
  border: 15px #969696 solid;
  background-color: #969696;
}
#return2selecter {
  font-size: small;
  text-decoration: underline;
  color: #969696;
  cursor: pointer;
}
</style>
<script>
// for encrypt message
import crypto from "crypto-js";
var CryptoJS = require("crypto-js");
// var dts = new Date().getDate();
var dts = "651127";
var passPhrase =
  "45b54c392cc235a79ce573f623b2f8023" + dts + "d6dd6edf2488805962a3d223be6566b";
const salt = CryptoJS.lib.WordArray.random(128 / 8);
const iv = CryptoJS.lib.WordArray.random(128 / 8);
const key = "0921b90b3b7dab492b4aa897e3d0ccffde0f59579fc0c6229213c" + dts + "94822466ce8";
// for HTTP response
import axios from "axios";
export default {
  data() {
    return {
      snackbarFlag: false,
      snackbarTimeout: 3000,
      snackbarText: "",
      name: "",
      imgURL: "",
      userId: "",
      email: "",
      barcode_url: "",
      inClient: false,
    };
  },
  created() {
    this.initializeLiff();
    //既存カード追加ボタンエリアを非表示にする
    // $("#area_migration").hide();
    // 0017120: 【みせめぐ】LINEミニアプリのボタン連打（チャタリング）対策
    $(".regist_btn").prop("disabled", false); //活性化
    $(".regist_btn").show(); //表示
  },
  mounted() {
    // ページ描画完了後の処理
    $("#main_title").css("width", window.outerWidth);
    // $('#modal-container').hide();
    genCalYears();
    //店舗選択オプション
    var select_shop = this.$_select_shop();
    if (select_shop == "1") {
      //店舗選択用selectオブジェクトを生成
      this.initShopList();
      $("#row_select_shop").show();
    } else {
      $("#row_select_shop").hide();
    }
    //電話番号入力オプション
    var telephone_number = this.$_telephone_number();
    if (telephone_number == "1") {
      $("#row_telephone").show();
    } else {
      $("#row_telephone").hide();
    }
    //メルアドに対応するみせめぐUserIDを取得する
    this.getUserID();
  },
  methods: {
    initializeLiff: function () {
      var me = this;
      liff.init(
        {
          liffId: process.env.VUE_APP_LIFF_ID,
        },
        (data) => {
          me.loginCheck();
        },
        (err) => {
          console.log("LIFF initialization failed", err);
        }
      );
    },
    loginCheck: async function () {
      var me = this;

      // md5()実行用ライブラリ読込
      var md5 = require("md5");

      // tokenを当日のみ有効（最大24時間）とするため日付を求めてmmddyyyyにしておく
      var dt = new Date();
      var year = dt.getFullYear();
      var month = dt.getMonth() + 1;
      var strMonth = "";
      if (month < 10) {
        strMonth = "0" + month;
      } else {
        strMonth = month.toString();
      }
      var date = dt.getDate();
      var strDate = "";
      if (date < 10) {
        strDate = "0" + date;
      } else {
        strDate = date.toString();
      }
      var mmddyyyy = strMonth + "-" + strDate + "-" + year;

      // 0016891 20240918 "liff init failure"エラーの対策で liff.ready の処理を追記
      liff.ready.then(() => {
        // ログインチェック
        if (liff.isLoggedIn()) {
          this.isClient = liff.isInClient();
          const idToken = liff.getDecodedIDToken();
          console.log(idToken.email); // print decoded idToken object
          //メルアドが取得できれば表示、取得エラーの場合は入力を促す
          var email = idToken.email;
          try {
            if (email == "undefined" || email == null || email == "") {
              var encrypted_mail = localStorage.getItem("lmmini_" + dts + "_maddr");
              var dec_email = CryptoJS.AES.decrypt(encrypted_mail, key, { iv: iv });
              // email = dec_email.toString(CryptoJS.enc.Utf8);
            }
          } catch (Exception) {
            email = "";
          }
          if (email != null) {
            $("#mail_addr").val(email);
          }

          // プロフィール取得
          liff
            .getProfile()
            .then((profile) => {
              me.name = profile.displayName;
              me.imgURL = profile.pictureUrl;
              me.userId = profile.userId;
              me.email = email;
              //me.barcode_img = barcode_url
              debugger;
            })
            .catch((err) => {
              console.log("error", err);
            });

          debugger;

          // （１）メルアドに対応するみせめぐユーザーIDを取得する（※すでにアプリでUIDを持っているか否かを判断するのに使用）
          var getuid_url = "";
          var debug_mode = this.$_debug_mode();
          //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
          var i_shopid = Number(this.$_shopid());
          if (debug_mode == "0") {
            getuid_url = this.$_debug_url();
          } else if (debug_mode == "2") {
            if (i_shopid % 2 == 0) {
              getuid_url = "https://sv2.misemeg.jp/";
            } else {
              getuid_url = "https://sv1.misemeg.jp/";
            }
          } else {
            if (i_shopid % 2 == 0) {
              getuid_url = "https://sv2.misemegu.jp/";
            } else {
              getuid_url = "https://sv1.misemegu.jp/";
            }
          }
          getuid_url += "appli/line/";
          getuid_url += "getMisemegUID.php?mail=";
          getuid_url += email;
          getuid_url +=
            "&security=" +
            md5(
              email +
                "5ca968c5c9c793ad75b49ac19b493ad2misemeg" +
                email +
                "!Busicom04510" +
                mmddyyyy
            );
          // window.alert('getMemInf = ' + getuid_url);
          axios
            .get(getuid_url)
            .then(
              (response) =>
                (document.getElementById("misemeg_uid").innerHTML = response.data)
            )
            .catch((error) => console.log(error));

          // （２）桁数変更情報をサーバーサイドのPHPから取得する
          var codeinfo_url = "";
          //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
          var i_shopid = Number(this.$_shopid());
          if (debug_mode == "0") {
            codeinfo_url = this.$_debug_url();
          } else if (debug_mode == "2") {
            if (i_shopid % 2 == 0) {
              codeinfo_url = "https://sv2.misemeg.jp/";
            } else {
              codeinfo_url = "https://sv1.misemeg.jp/";
            }
          } else {
            if (i_shopid % 2 == 0) {
              codeinfo_url = "https://sv2.misemegu.jp/";
            } else {
              codeinfo_url = "https://sv1.misemegu.jp/";
            }
          }
          //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
          var miseid = this.$_t_shopid();
          //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
          if (debug_mode == "2") {
            miseid = this.$_shopid();
          }
          //オーナーIDをグローバル変数から取得する（※初期値は試験用）
          var prmid = this.$_t_prmid();
          //デバッグモード=2（本番用）の場合のみ本番用変数で置換する 0015080
          if (debug_mode == "2") {
            prmid = this.$_prmid();
          }
          codeinfo_url += "appli/line/";
          codeinfo_url += "getDigitChangeInfo.php?mail=";
          codeinfo_url += email;
          codeinfo_url += "&shopid=";
          codeinfo_url += miseid;
          codeinfo_url += "&prmid=";
          codeinfo_url += prmid;
          codeinfo_url +=
            "&security=" +
            md5(
              email +
                "5ca968c5c9c793ad75b49ac19b493ad2misemeg" +
                email +
                "!Busicom04510" +
                mmddyyyy
            );
          // window.alert('getMemInf = ' + codeinfo_url);
          axios
            .get(codeinfo_url)
            //.then((response) => this.users = response.data)
            .then(
              (response) =>
                (document.getElementById("chg_digit_info").innerHTML = response.data)
            )
            .catch((error) => console.log(error));
        } else {
          // ログインまだ
          this.$router.push({ name: "home" });
        }
      }); // end of liff.ready.then
    },
    logout: function () {
      // ログアウト
      if (liff.isLoggedIn()) {
        liff.logout();
        this.$router.push({ name: "home" });
      }
    },
    returntop: function () {
      if (liff.isLoggedIn()) {
        // line-mini トップ画面に戻る
        this.$router.push({ name: "login" });
      }
    },
    return2selecter: function () {
      if (liff.isLoggedIn()) {
        // line-mini トップ画面に戻る
        this.$router.push({ name: "regist_selecter" });
      }
    },
    /**
     * 新規会員登録 regist
     */
    regist: async function () {
      // if(window.confirm("この内容で「新規会員証」を登録してよろしいですか？")){
      // $('#modal-container').show();
      // window.alert('会員証登録が完了したら画面左上の「×」を押して登録画面を閉じてください。');
      // md5ライブラリの読み込み
      var md5 = require("md5");
      // tokenを当日のみ有効（最大24時間）とするため日付を求めてmmddyyyyにしておく
      var dt = new Date();
      var year = dt.getFullYear();
      var month = dt.getMonth() + 1;
      var strMonth = "";
      if (month < 10) {
        strMonth = "0" + month;
      } else {
        strMonth = month.toString();
      }
      var date = dt.getDate();
      var strDate = "";
      if (date < 10) {
        strDate = "0" + date;
      } else {
        strDate = date.toString();
      }
      var mmddyyyy = strMonth + "-" + strDate + "-" + year;

      // email取得用 idTokenの取得
      // const idToken = liff.getDecodedIDToken();
      // var line_email = idToken.email;

      // デジタル会員証登録・ユーザー登録の実行
      if (liff.isLoggedIn()) {
        // 0017120: 【みせめぐ】LINEミニアプリのボタン連打（チャタリング）対策
        $(".regist_btn").prop("disabled", true); //非活性化
        $(".regist_btn").hide(); //非表示

        //(1)性別
        var selected_gender = $('input:radio[name="gender"]:checked').val();
        //(2)生年月日
        var selected_birth_date =
          $("#bd_year").val() + "/" + $("#bd_month").val() + "/" + $("#bd_date").val();
        //(3)都道府県
        var selected_region = $("#region").val();
        //(4)選択店舗
        var selected_shopid = $("#select_shop").val();

        /*
          //(5)電話番号
          var telephone_number = this.$_telephone_number();
          // window.alert(telephone_number);
          var selected_tel = '';
          selected_tel = $('#telephone').val();
          if(telephone_number=='1'){
            if(!telephone_number){
                window.alert('電話番号を入力してください。');
              // 0017120: 【みせめぐ】LINEミニアプリのボタン連打（チャタリング）対策
               // 不活性化した登録ボタンを表示・活性化する
                $('.regist_btn').prop('disabled',false); // 活性化
                $('.regist_btn').show(); // 表示
                return;
            }          
          }
          */
        var selected_tel = "";

        //店舗コード
        var selected_shopid = $("#select_shop").val();
        // ▼▼▼▼▼▼▼▼ 店舗選択サイトでは下記一行をかならずコメントアウトすること ▼▼▼▼▼▼▼▼
        // var selected_shopid = miseid;
        // ▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲
        if (!selected_shopid) {
          window.alert("よく利用する店舗を選択してください");
          $("#select_shop").css("border", "4px solid orange");
          // 0017120: 【みせめぐ】LINEミニアプリのボタン連打（チャタリング）対策
          // 不活性化した登録ボタンを表示・活性化する
          $(".regist_btn").prop("disabled", false); // 活性化
          $(".regist_btn").show(); // 表示
          return;
        } else {
          //選択店舗を暗号化してlocalStroageに保存する
          //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
          var miseid = this.$_t_shopid();
          //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
          var debug_mode = this.$_debug_mode();
          if (debug_mode == "2") {
            miseid = this.$_shopid();
          }
          localStorage.removeItem("lmmini_" + dts + "_myshopid");
          const ecrypted_myshopid = CryptoJS.AES.encrypt(selected_shopid, key, {
            iv: iv,
          }).toString();
          localStorage.setItem(
            "lmmini_" + dts + "_myshopid",
            ecrypted_myshopid.toString()
          );
          // window.alert('lmmini_*_myshopid = ' + selected_shopid);
        }

        //メールアドレス
        var mail_addr = $("#mail_addr").val();
        if (!mail_addr) {
          window.alert("メールアドレスを入力してください。");
          // 0017120: 【みせめぐ】LINEミニアプリのボタン連打（チャタリング）対策
          // 不活性化した登録ボタンを表示・活性化する
          $(".regist_btn").prop("disabled", false); // 活性化
          $(".regist_btn").show(); // 表示
          return;
        }

        if (window.confirm("この内容で「新規会員証」を登録してよろしいですか？")) {
          /**
           * setTmpExtendUserInfo.php をキックして[LINE_TMP]テーブルにユーザー拡張属性（性別,生年月日,都道府県）を登録する
           */

          var codeinfo_url = "";
          //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
          var i_shopid = Number(this.$_shopid());
          if (debug_mode == "0") {
            codeinfo_url = this.$_debug_url();
          } else if (debug_mode == "2") {
            if (i_shopid % 2 == 0) {
              codeinfo_url = "https://sv2.misemeg.jp/";
            } else {
              codeinfo_url = "https://sv1.misemeg.jp/";
            }
          } else {
            if (i_shopid % 2 == 0) {
              codeinfo_url = "https://sv2.misemegu.jp/";
            } else {
              codeinfo_url = "https://sv1.misemegu.jp/";
            }
          }
          codeinfo_url += "appli/line/";
          codeinfo_url += "setTmpExtendUserInfo.php?mail=";
          codeinfo_url += mail_addr;
          codeinfo_url += "&gender=";
          codeinfo_url += selected_gender;
          codeinfo_url += "&birth=";
          codeinfo_url += selected_birth_date;
          codeinfo_url += "&region_id=";
          codeinfo_url += selected_region;
          codeinfo_url += "&tel=";
          codeinfo_url += selected_tel;
          codeinfo_url += "&shopid=";
          codeinfo_url += selected_shopid;
          // codeinfo_url += "&security=" + md5(idToken.email + "5ca968c5c9c793ad75b49ac19b493ad2misemeg" + idToken.email + "!Busicom04510" + mmddyyyy);
          codeinfo_url +=
            "&security=" +
            md5(
              mail_addr +
                "5ca968c5c9c793ad75b49ac19b493ad2misemeg" +
                mail_addr +
                "!Busicom04510" +
                mmddyyyy
            );
          // window.alert('setTmpExtendUserInfo.php = ' + codeinfo_url);
          axios
            .get(codeinfo_url)
            //.then((response) => this.users = response.data)
            .then(
              (response) =>
                (document.getElementById("member_info").innerHTML = response.data)
            )
            .catch((error) => console.log(error));

          //みせめぐ登録APIに送信するBase64エンコードしたパラメータ
          var enc64_uid = "";
          var enc64_sid = "";
          var enc64_mail = "";
          var enc64_pwd = "";
          //みせめぐ店舗コードをグローバル変数から取得してenn64エンコードする
          var miseid = $("#select_shop").val();
          /*
          var select_shop = this.$_select_shop();
          if(select_shop == "1"){
            miseid = selected_shopid;
          }
          */
          enc64_sid = btoa(miseid);
          enc64_mail = btoa(mail_addr);
          //パスワード ※LINE連携以外のログインは使用しない前提で固定文字列'misemegpwd'とする
          enc64_pwd = btoa("misemegpwd");
          //端末モード（1固定=Android端末と同義）
          var emode = "1";

          //みせめぐMini個人情報無しサイト専用
          var enc64_gender = btoa(selected_gender);
          var enc64_birth = btoa(selected_birth_date);
          var enc64_region = btoa(selected_region);

          //メルアドを暗号化してlocalStroageに保存する
          localStorage.removeItem("lmmini_" + dts + "_maddr");
          const ecrypted_mail_addr = CryptoJS.AES.encrypt(mail_addr, key, {
            iv: iv,
          }).toString();
          localStorage.setItem("lmmini_" + dts + "_maddr", ecrypted_mail_addr.toString());

          //みせめぐ登録用WebAPIのURL設定(REST)
          // 0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
          var i_shopid = Number(this.$_shopid());
          var ext_server = "https://test.misemegu.jp/";
          // debug_mode=2（本番運用環境）でない場合はSTG環境とする
          if (debug_mode == "0") {
            ext_server = "http://localhost/mg/";
          }
          if (debug_mode == "2") {
            ext_server = "https://misemeg.jp/";
            if (i_shopid % 2 == 0) {
              ext_server = "https://sv2.misemeg.jp/";
            } else {
              ext_server = "https://sv1.misemeg.jp/";
            }
          } else {
            ext_server = "https://test.misemegu.jp/";
            if (i_shopid % 2 == 0) {
              ext_server = "https://sv2.misemegu.jp/";
            } else {
              ext_server = "https://sv1.misemegu.jp/";
            }
          }
          // ext_server = "http://localhost/mg/";
          //初期Versionのリンク（生年月日・性別がTV同期できない版）mode : regist
          // var url = ext_server + "direct_url/api/member/////regist/" + enc64_mail + "/" + enc64_sid + "//" + enc64_pwd + "/" + emode;
          // 1.email 2.shopid 3.jankenid 4.password 5.sex 6.dob 7.tel 8.todofuken 9.emode
          //修正Versionのリンク（生年月日・性別がTV同期できるように修正した版）mode : regist2
          var url =
            ext_server +
            "direct_url/api/member/////regist2/" +
            enc64_mail +
            "/" +
            enc64_sid +
            "//" +
            enc64_pwd +
            "/" +
            enc64_gender +
            "/" +
            enc64_birth +
            "//" +
            enc64_region +
            "/" +
            emode;
          // window.alert(url);
          //for debug
          debugger;
          //WebAPIに画面遷移（同一Window）
          //window.location.href = url;
          //みせめぐWebAPIのindex.phpをREST引数渡しで新Window win_m で開く
          // var win_m = await window.open(url , '_blank','scrollbars=no,status=no,toolbar=no,location=no,menubar=no,resizable=yes,');
          var win_m = window.open(
            url,
            "_blank",
            "scrollbars=no,status=no,toolbar=no,location=no,menubar=no,resizable=yes,"
          );
          // var win_m = window.location.href = url;
          debugger;
          // setTimeout(this.$router.push({ name: 'login' }), 4000);
          setTimeout(this.$router.push({ name: "bridge" }), 1000);
        } //end of confirm

        // 0017120: 【みせめぐ】LINEミニアプリのボタン連打（チャタリング）対策
        $(".regist_btn").prop("disabled", false); // 活性化
        $(".regist_btn").show(); // 表示
      } //end of LIFF.isLoggedIn()
      //  } //end of confirm
    },
    /**
     * LIFFログイン情報から取得したメルアドを持つみせめぐユーザーのUIDを取得する
     */
    getUserID: async function () {
      // 会員証移行処理に進むために登録した会員情報の一部を取得する
      // md5ライブラリの読み込み
      var md5 = require("md5");
      // tokenを当日のみ有効（最大24時間）とするため日付を求めてmmddyyyyにしておく
      var dt = new Date();
      var year = dt.getFullYear();
      var month = dt.getMonth() + 1;
      var strMonth = "";
      if (month < 10) {
        strMonth = "0" + month;
      } else {
        strMonth = month.toString();
      }
      var date = dt.getDate();
      var strDate = "";
      if (date < 10) {
        strDate = "0" + date;
      } else {
        strDate = date.toString();
      }
      var mmddyyyy = strMonth + "-" + strDate + "-" + year;
      //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
      var miseid = this.$_t_shopid();
      //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
      var debug_mode = this.$_debug_mode();
      if (debug_mode == "2") {
        miseid = this.$_shopid();
      }
      // 引数１．mail address
      this.initializeLiff();
      const idToken = liff.getDecodedIDToken();
      console.log(idToken.email); // print decoded idToken object
      //メルアドが取得できれば表示、取得エラーの場合は入力を促す
      var email = idToken.email;
      try {
        if (email == "undefined" || email == null || email == "") {
          var encrypted_mail = localStorage.getItem("lmmini_" + dts + "_maddr");
          var dec_email = CryptoJS.AES.decrypt(encrypted_mail, key, { iv: iv });
          email = dec_email.toString(CryptoJS.enc.Utf8);
        }
      } catch (Exception) {
        email = "";
      }
      //----------------------------
      // みせめぐユーザーIDの取得
      //----------------------------
      var codeinfo_url = "";
      //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
      var i_shopid = Number(this.$_shopid());
      if (debug_mode == "0") {
        codeinfo_url = this.$_debug_url();
      } else if (debug_mode == "2") {
        if (i_shopid % 2 == 0) {
          codeinfo_url = "https://sv2.misemeg.jp/";
        } else {
          codeinfo_url = "https://sv1.misemeg.jp/";
        }
      } else {
        if (i_shopid % 2 == 0) {
          codeinfo_url = "https://sv2.misemegu.jp/";
        } else {
          codeinfo_url = "https://sv1.misemegu.jp/";
        }
      }
      codeinfo_url += "appli/line/";
      codeinfo_url += "getMisemegUID.php?mail=";
      codeinfo_url += email;
      codeinfo_url +=
        "&security=" +
        md5(
          email +
            "5ca968c5c9c793ad75b49ac19b493ad2misemeg" +
            email +
            "!Busicom04510" +
            mmddyyyy
        );
      // window.alert(codeinfo_url);
      await axios
        .get(codeinfo_url)
        // .then((response) => this.users = response.data)
        .then(
          (response) => (document.getElementById("misemeg_uid").innerHTML = response.data)
        )
        // .then((response) => $('#member_info').val = response.data)
        .catch((error) => console.log(error));
    },
    initShopList: function () {
      // md5ライブラリの読み込み
      var md5 = require("md5");
      // tokenを当日のみ有効（最大24時間）とするため日付を求めてmmddyyyyにしておく
      var dt = new Date();
      var year = dt.getFullYear();
      var month = dt.getMonth() + 1;
      var strMonth = "";
      if (month < 10) {
        strMonth = "0" + month;
      } else {
        strMonth = month.toString();
      }
      var date = dt.getDate();
      var strDate = "";
      if (date < 10) {
        strDate = "0" + date;
      } else {
        strDate = date.toString();
      }
      var mmddyyyy = strMonth + "-" + strDate + "-" + year;
      //GeoLocationで現在地の緯度・経度を取得する
      var tmp_lat = "";
      try {
        tmp_lat = this.$_shoplat();
      } catch (Exception) {
        tmp_lat = "";
      }
      var tmp_lng = "";
      try {
        tmp_lng = this.$_shoplng();
      } catch (Exception) {
        tmp_lng = "";
      }
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            let coords = position.coords;
            tmp_lat = coords.latitude;
            tmp_lng = coords.longitude;
          }.bind(this),
          function (error) {
            // エラー処理を書く
          }
        );
      } else {
        // エラー処理を書く
      }
      if (isNaN(tmp_lat)) {
        tmp_lat = this.$_shoplat();
      }
      if (isNaN(tmp_lng)) {
        tmp_lng = this.$_shoplng();
      }
      var shoplist_url = "";
      var debug_mode = this.$_debug_mode();
      //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
      var i_shopid = Number(this.$_shopid());
      if (debug_mode == "0") {
        shoplist_url = this.$_debug_url();
      } else if (debug_mode == "2") {
        if (i_shopid % 2 == 0) {
          shoplist_url = "https://sv2.misemeg.jp/";
        } else {
          shoplist_url = "https://sv1.misemeg.jp/";
        }
      } else {
        if (i_shopid % 2 == 0) {
          shoplist_url = "https://sv2.misemegu.jp/";
        } else {
          shoplist_url = "https://sv1.misemegu.jp/";
        }
      }
      //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
      var miseid = this.$_t_shopid();
      //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
      if (debug_mode == "2") {
        miseid = this.$_shopid();
      }
      //オーナーIDをグローバル変数から取得する（※初期値は試験用）
      var ownerid = this.$_t_prmid();
      //デバッグモード=2（本番用）の場合のみ本番用オーナーIDで置換する 0015080
      if (debug_mode == "2") {
        ownerid = this.$_prmid();
      }
      shoplist_url += "appli/line/";
      shoplist_url += "getShopList3.php?shopid=";
      shoplist_url += miseid;
      shoplist_url += "&prmid=";
      shoplist_url += ownerid;
      shoplist_url +=
        "&security=" +
        md5(
          miseid +
            "5ca968c5c9c793ad75b49ac19b493ad2misemeg" +
            miseid +
            "!Busicom04510" +
            mmddyyyy
        );
      shoplist_url += "&lat=" + tmp_lat + "&lng=" + tmp_lng;
      // window.alert('shoplist_url = ' + shoplist_url);
      axios
        .get(shoplist_url)
        //.then((response) => this.users = response.data)
        .then(
          (response) =>
            (document.getElementById("area_select_shop").innerHTML = response.data)
        )
        .catch((error) => console.log(error));
    },
    sendLINE: function () {
      var me = this;
      // LINEに送る
      liff
        .sendMessages([
          {
            type: "text",
            text: "あなたのアイコン画像を送ります",
          },
          {
            type: "image",
            originalContentUrl: me.imgURL,
            previewImageUrl: me.imgURL,
          },
        ])
        .then(() => {
          console.log("message sent");
          me.showSnackbar("LINEに送信しました");
        })
        .catch((err) => {
          console.log("error", err);
          me.showSnackbar("LINEに送信失敗しました");
        });
    },
    showSnackbar(text) {
      this.snackbarFlag = true;
      this.snackbarText = text;
      setTimeout(() => {
        this.snackbarFlag = false;
        this.snackbarText = "";
      }, this.snackbarTimeout);
    },
    getBarcodeParam() {
      md5();
    },
    // 日付選択プルダウン「年」「月」「日」をどれか一つでも動かした場合に年月日のValidationをかける
    // カレンダーに存在しない日付の場合はメッセージ表示後に「日」を1日に戻す
    calValidate: function () {
      var y = $("#bd_year").val();
      var m = $("#bd_month").val();
      var d = $("#bd_date").val();
      var date = new Date(y, m - 1, d);
      if (date.getFullYear() != y || date.getMonth() != m - 1 || date.getDate() != d) {
        $("#bd_date").val("1");
        window.alert(y + "/" + m + "/" + d + "はカレンダーに存在しない日付です。");
      } else {
        //今日
        var today = new Date();
        //今年の誕生日
        var thisYearsBirthday = new Date(today.getFullYear(), m - 1, d);
        //年齢
        var age = today.getFullYear() - y;
        if (today < thisYearsBirthday) {
          //今年まだ誕生日が来ていない
          age--;
        }
        // window.alert('本日時点で ' + age + ' 才です。');
        var msg_age = "（" + age + "才）";
        $("#calc_age").html(msg_age);
      }
    },
  },
};
//生年月日選択プルダウンの「年」を120年分初期化
//ログイン「年」に30才になる「年」を選択状態にする
function genCalYears() {
  var today = new Date();
  var end_year = today.getFullYear();
  var start_year = end_year - 120;
  var icnt = 0;
  for (var y = start_year; y <= end_year; y++) {
    if (icnt == 91) {
      var opt_str = '<option value="' + y + '" selected>' + y + "年</option>";
    } else {
      var opt_str = '<option value="' + y + '">' + y + "年</option>";
    }
    $("#bd_year").append(opt_str);
    icnt++;
  }
}
function getAge() {
  //今日
  var today = new Date();
  var bd_year = $("#bd_year").val();
  var bd_month = $("#bd_month").val();
  var bd_date = $("#bd_month").val();
  //今年の誕生日
  var thisYearsBirthday = new Date(today.getFullYear(), bd_month - 1, bd_date);
  //年齢
  var age = today.getFullYear() - bd_year.year;
  if (today < thisYearsBirthday) {
    //今年まだ誕生日が来ていない
    age--;
  }
  return age;
}
</script>
